import { reactive } from 'vue';

// 所有短信发送共享一次性图形验证流程，只有发送成功才结束页面的等待。
export function useSmsCaptcha(api) {
  const state = reactive({ visible: false, loading: false, sending: false, captchaId: '', image: '', answer: '', error: '' });
  let pending;
  let version = 0;

  async function refresh(clearError = true) {
    if (state.loading || state.sending || !state.visible) return;
    if (clearError) state.error = '';
    const current = ++version;
    state.loading = true;
    state.captchaId = '';
    state.image = '';
    state.answer = '';
    try {
      const result = await api.captcha();
      if (current !== version) return;
      if (!result?.captchaId || !result?.base64) throw new Error('图形验证码加载失败，请点击重试');
      state.captchaId = result.captchaId;
      state.image = result.base64;
    } catch (error) {
      if (current === version) state.error = error.message || '图形验证码加载失败，请点击重试';
    } finally {
      if (current === version) state.loading = false;
    }
  }

  function send(data) {
    if (pending) return Promise.reject(new Error('请先完成当前图形验证'));
    if (data.channel !== 'PHONE') return api.sendVerificationCode(data);
    state.visible = true;
    state.error = '';
    const result = new Promise((resolve, reject) => { pending = { data: { ...data }, resolve, reject }; });
    refresh();
    return result;
  }

  async function confirm() {
    if (!pending || state.loading || state.sending) return;
    if (!state.captchaId || !state.answer.trim()) {
      state.error = '请输入图形验证码';
      return;
    }
    state.sending = true;
    state.error = '';
    const request = pending;
    try {
      const result = await api.sendVerificationCode({ ...request.data, captchaId: state.captchaId, captchaValue: state.answer.trim() });
      if (pending !== request) return;
      pending = null;
      state.visible = false;
      request.resolve(result);
    } catch (error) {
      if (pending !== request) return;
      state.error = error.message || '发送失败，请重新验证后重试';
      // 后端已消费本次挑战，任何失败都重新取图，不能复用旧答案。
      state.sending = false;
      await refresh(false);
    } finally {
      state.sending = false;
    }
  }

  function cancel(force = false) {
    if (state.sending && !force) return;
    ++version;
    const request = pending;
    pending = null;
    state.visible = false;
    state.loading = false;
    state.captchaId = '';
    state.image = '';
    state.answer = '';
    request?.reject(new Error('已取消图形验证'));
  }

  return { state, send, refresh, confirm, cancel };
}
